import module from 'recursoshumanos/module.js'
import template from './template.html'
import {orderBy, cloneDeep} from 'lodash'

const obtenerDatos = (result) => {
  let data = []
  let cadena = result.length
  let inicio = 0
  let fin = 295

  while (fin < cadena) {
    let item = result.slice(inicio, fin)
    if (item.substr(0, 2) === '03') {
      data.push(crearObjetoSUA(item))
    }
    if (item.substr(0, 2) === '04') {
      fin = cadena
    }
    inicio = fin
    fin = fin + 295
  }
  return data
}

const crearObjetoSUA = (item) => {
  try {
    return {
      registroPatronal: item.substr(2, 11),
      rfcPatronal: item.substr(14, 12),
      periodo: item.substr(26, 4),
      mes: item.substr(30, 2),
      fecha: new Date(`${item.substr(30, 2)}-01-${item.substr(26, 4)}`),
      nss: item.substr(32, 11),
      rfc: item.substr(43, 13),
      curp: item.substr(56, 18),
      nombre: getNombre(item.substr(94, 50), 2),
      apellidoPaterno: getNombre(item.substr(94, 50), 0),
      apellidoMaterno: getNombre(item.substr(94, 50), 1),
      salario: +((item.substr(142, 9)) / 100).toFixed(2),
      dias: +item.substr(153, 2),
      diasBimestre: +item.substr(215, 2),
      incapacidades: +item.substr(155, 2),
      incapacidadesBimestre: +item.substr(217, 2),
      faltas: item.substr(157, 2),
      faltasBimestral: item.substr(219, 2),
      cuotaFija: +(item.substr(159, 7)) / 100,
      retiro: +(item.substr(221, 7)) / 100,
      censatiaEdadAvanzadaPatronal: +(item.substr(235, 7)) / 100,
      censatiaEdadAvanzadaObrero: +(item.substr(242, 7)) / 100,
      aportacionPatronal: +(item.substr(263, 7)) / 100,
      amortizacion: +(item.substr(270, 7)) / 100 === 0 ? '-' : +(item.substr(270, 7)) / 100,
      infonavit: (+(item.substr(270, 7)) + Number(item.substr(263, 7))) / 100,
      excedentePatronal: +(item.substr(166, 7)) / 100,
      prestacionDineroPatronal: +(item.substr(173, 7)) / 100,
      gastoMedicoPensionPatronal: +(item.substr(180, 7)) / 100,
      riesgoTrabajo: +(item.substr(187, 7)) / 100,
      invalidezVidaPatronal: +(item.substr(194, 7)) / 100,
      guarderiaPrestacionSocial: +(item.substr(201, 7)) / 100,
      subtotal: (+(item.substr(221, 7)) + +(item.substr(235, 7)) + +(item.substr(242, 7))) / 100,
      total: (+(item.substr(159, 7)) + +(item.substr(166, 7))
        + +(item.substr(173, 7)) + +(item.substr(180, 7)) +
        +(item.substr(187, 7)) + +(item.substr(194, 7)) + +(item.substr(201, 7))) / 100,
    }
  } catch (e) {
    console.error(e)
  }
}

const getNombre = (nombre, posicion) => {
  let array = nombre.split('$')

  return array[posicion]
}

const bimestral = (data) => {
  let sinBajas = data.filter(item => +item[3] !== 2)
  return sinBajas.every((item) => +(item[9].replace(',', '')))

}

const datosEmision = (archivo, delimiter = ',') => {

  const regexp = new RegExp('(\\' + delimiter + '|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\' + delimiter + '\\r\\n]*))', 'gi')
  let data = [[]]
  let matches

  while (matches = regexp.exec(archivo)) {
    const strMatchedDelimiter = matches[1]

    if (strMatchedDelimiter.length && strMatchedDelimiter !== delimiter) {
      data.push([])
    }

    data[data.length - 1].push(matches[2] ? matches[2].replace(/""/g, '"') : matches[3])
  }
  data = data.slice(3)
  data.pop()

  let esBimestral = bimestral(data)

  if (esBimestral) {
    return agruparEmision(data.map(item => {
      return {
        nss: item[0].trim(),
        nombre: item[1].trim(),
        origenMovimiento: item[2].trim(),
        tipoMovimiento: item[3].trim(),
        fechaMovimiento: generarFecha(item[4].trim()),
        dias: +item[5] || null,
        salario: +(+(item[6].replace(',', ''))).toFixed(2) || null,
        retenido: +(+(item[7].replace(',', ''))).toFixed(2) || null,
        censatiaPatronal: +(+(item[8].replace(',', ''))).toFixed(2) || null,
        censatiaObrero: +(+(item[9].replace(',', ''))).toFixed(2) || null,
        subtotal: +(+(item[10].replace(',', ''))).toFixed(2) || null,
        aportacionPatronal: +(+(item[11].replace(',', ''))).toFixed(2) || null,
        tipoDescuento: +(+(item[12].replace(',', ''))).toFixed(2) || null,
        descuento: +(+(item[13].replace(',', ''))).toFixed(2) || null,
        numeroCredito: +(+(item[14].replace(',', ''))).toFixed(2) || null,
        amortizacion: +(+(item[15].replace(',', ''))).toFixed(2) || null,
        subtotalInfonavit: +(+(item[16].replace(',', ''))).toFixed(2) || null,
        total: +(+(item[17].replace(',', ''))).toFixed(2) || null,
        bimestral: true,
      }
    }))
  } else {
    return agruparEmision(data.map((item) => {
      return {
        nss: item[0].trim(),
        nombre: item[1].trim(),
        origenMovimiento: item[2].trim(),
        tipoMovimiento: item[3].trim(),
        fechaMovimiento: generarFecha(item[4].trim()),
        dias: +(+(item[5].replace(',', ''))).toFixed(2) || null,
        salario: +(+(item[6].replace(',', ''))).toFixed(2) || null,
        cuotaFija: +(+(item[7].replace(',', ''))).toFixed(2) || null,
        excedentePatronal: +(+(item[8].replace(',', ''))).toFixed(2) || null,
        excedenteObrero: +(+(item[9].replace(',', ''))).toFixed(2) || null,
        prestacionesDineroPatronal: +(+(item[10].replace(',', ''))).toFixed(2) || null,
        prestacionesDineroObrero: +(+(item[11].replace(',', ''))).toFixed(2) || null,
        gastoMedicosPensionadosPatronal: +(+(item[12].replace(',', ''))).toFixed(2) || null,
        gastoMedicosPensionadosObrero: +(+(item[13].replace(',', ''))).toFixed(2) || null,
        riesgoTrabajo: +(+(item[14].replace(',', ''))).toFixed(2) || null,
        invalidezVidaPatronal: +(+(item[15].replace(',', ''))).toFixed(2) || null,
        invalidezVidaObrero: +(+(item[16].replace(',', ''))).toFixed(2) || null,
        guarderiasPrestacionesSociales: +(+(item[17].replace(',', ''))).toFixed(2) || null,
        total: +(+(item[18].replace(',', ''))).toFixed(2) || null,
        bimestral: false,
      }
    }))
  }
}

const generarFecha = (fecha) => {
  let fechaArray = fecha.split('/')
  if (fechaArray.length < 2) return null
  let meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']

  return new Date(`${meses.indexOf(fechaArray[1]) + 1}-${fecha[0]}-${fechaArray[2]}`)
}

const agruparEmision = (data, propiedad = 'nss') => {
  return data.reduce((groups, item) => {
    let valor = item[propiedad]
    groups[valor] = groups[valor] || {
      nombre: item.nombre,
      nss: item.nss,
      bimestral: item.bimestral,
      pagos: [],
    }
    groups[valor].pagos.push(item)
    return groups
  }, {})
}

const indicadores = [
  {id: 1, descripcion: 'Errores', cantidad: 0},
  {id: 2, descripcion: 'Advertencias', cantidad: 0},
  {id: 3, descripcion: 'Correctos', cantidad: 0},
]

const sanitizar = (value) => value.replace(/[^a-zA-Z ]/g, '')

export class RecursosHumanosPagosSuaComponent {
  busqueda
  current_message_nss = null
  filtro = ``
  colaboradores = []
  empleados = []
  operadoras = []
  acceptSua = '.SUA,.sua'
  erroneos = null
  idIndicador = null
  indicadores = indicadores
  acceptEmision = '.csv,application/vnd.ms-excel'
  data = {
    operadora_id: undefined,
    registro_patronal_id: undefined,
    tipo_id: undefined,
  }
  periodo = null
  mes = null
  registros = []
  opciones = [{id: 1, descripcion: 'Bimestral'}, {id: 2, descripcion: 'Mensual'}]
  archivos = null
  step = 1
  emision = null
  sua = null

  constructor ($location, $state, RecursoshumanosOperadorasService, RecursoshumanosRegistropatronalService) {
    this.$location = $location
    this.$state = $state
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursoshumanosRegistropatronalService = RecursoshumanosRegistropatronalService
  }

  $onChanges (changes) {
    if (changes.busqueda) {
      this.data.operadora_id = this.busqueda.operadora_id || undefined
      this.data.registro_patronal_id = this.busqueda.registro_patronal_id || undefined
      this.data.tipo_id = this.busqueda.tipo_id || undefined
    }
  }

  $onInit () {
    this.promise = this.RecursoshumanosOperadorasService.get()
      .then((response) => (this.operadoras = orderBy(response.data, ['nombre'])))
    if (this.data.operadora_id) this.registro(true)
  }

  generarEmision (texto) {
    this.emision_array = Object.values(datosEmision(texto))
    this.validarEmision()
  }

  generarSUA (texto) {
    if (this.step === 1) {
      this.sua_array = obtenerDatos(texto)
      this.validarSUA()
    } else {
      this.actualizarSUA(texto)
    }
  }

  validarSUA () {
    if (this.data.registro_patronal_id && this.sua_array && this.sua_array[0].registroPatronal !== this.data.registro_patronal_id) {
      this.sua_error = 'Registro patronal no coincide con el archivo'
      this.sua = false
    } else {
      this.sua = true
      this.sua_error = null
    }
  }

  validarEmision () {
    if (this.data.tipo_id && this.emision_array) {
      this.emision = true
      let bimestral = this.data.tipo_id === 1
      if (bimestral !== this.emision_array[0].bimestral) {
        this.emision_error = 'La periodicidad no coincide con el archivo'
        this.emision = false
      } else {
        this.emision_error = null
      }
      try {
        if (this.emision_array[0].nss.length !== 11) {
          this.emision_error = 'Formato errorneo del archivo'
          this.emision = false
        }
      } catch (e) {
        this.emision_error = 'E.Formato errorneo del archivo'
      }
    }
  }

  registro (refresco) {
    if (!refresco) {
      this.data.registro_patronal_id = undefined
    }

    this.registros = []
    this.RecursoshumanosRegistropatronalService.get(this.data.operadora_id)
      .then(response => (this.registros = response.data))
      .catch(error => (console.error(error)))
  }

  actualizarLista () {
    this.seleccionados = this.empleados.filter(item => item.seleccionado)
    this.resultados = [...this.resultados]
  }

  comparar () {
    this.siguiente = true
    this.suaTotal = 0
    this.emisionTotal = 0
    this.elemento = {
      nombre: '',
      sua: [],
      emision: [],
      indicador: 3,
      notas: '',
      nss: '',
      amortizacion: 0,
      descuento: 0,
      dias: 0,
      salario: 0,
      subtotal: 0,
      infonavit: 0,
      total: 0,
    }

    this.emision_array.forEach((emision) => {
      emision.pagos = orderBy(emision.pagos, ['fechaMovimiento'])

      let objeto = cloneDeep(this.elemento)
      emision.pagos.forEach(item => {
        objeto.nombre = item.nombre
        objeto.nss = item.nss
        objeto.salario = item.salario || objeto.salario
        objeto.amortizacion += item.amortizacion || 0
        objeto.descuento += item.descuento || 0
        objeto.dias += item.dias || 0
        objeto.subtotal += item.subtotal || 0
        objeto.infonavit += item.subtotalInfonavit || 0
        objeto.total += item.total || 0
        item.amortizacion = item.amortizacion || '-'
        item.descuento = item.descuento || '-'
        objeto.emision.push(item)
      })
      objeto.amortizacion = objeto.amortizacion === 0 ? '-' : objeto.amortizacion
      objeto.descuento = objeto.descuento === 0 ? '-' : objeto.descuento
      this.emisionTotal += emision.bimestral ? objeto.subtotal : objeto.total
      let sua = this.sua_array.find((item) => emision.nss === item.nss) || null

      if (!sua) {
        objeto.indicador = 1
      } else {
        objeto.sua.push(sua)
        sua.nombreCompleto = `${sua.apellidoPaterno.trim()} ${sua.apellidoMaterno.trim()} ${sua.nombre.trim()}`

        if (objeto.amortizacion !== sua.amortizacion) {
          objeto.indicador = 2
          objeto.amortizacion = false
        }

        if (sua.salario.toFixed(2) !== objeto.salario.toFixed(2)) {
          objeto.indicador = 2
          objeto.salario = false
        }
        if (sua.dias !== objeto.dias && sua.diasBimestre !== objeto.dias) {
          objeto.indicador = 2
          objeto.dias = false
        }
        if (sanitizar(sua.nombreCompleto) !== sanitizar(emision.nombre.trim())) {
          objeto.indicador = 2
          objeto.nombre = false
        }
        if (+(sua.subtotal.toFixed(2)) !== +(objeto.subtotal.toFixed(2)) && emision.bimestral) {
          objeto.indicador = 2
          objeto.subtotal = false
        }
        if (sua.infonavit.toFixed(2) !== objeto.infonavit.toFixed(2) && emision.bimestral) {
          objeto.indicador = 2
          objeto.infonavit = false
        }
        if (sua.total.toFixed(2) !== objeto.total.toFixed(2) && !emision.bimestral) {
          objeto.indicador = 2
          objeto.total = false
        }

        if (!emision.bimestral && objeto.dias && objeto.total && objeto.nombre) {
          objeto.indicador = 3
        }

        if (emision.bimestral && objeto.dias && objeto.subtotal && objeto.infonavit && objeto.nombre) {
          objeto.indicador = 3
        }
      }
      objeto.busqueda = `${objeto.nombre}|${objeto.nss}`
      this.empleados.push(objeto)
    })

    this.sua_array.forEach((sua) => {
      this.suaTotal += this.data.tipo_id === 1 ? sua.subtotal || 0 : sua.total || 0
      if (!this.empleados.find((item) => sua.nss === item.nss)) {
        let objeto = cloneDeep(this.elemento)
        sua.nombreCompleto = `${sua.apellidoPaterno.trim()} ${sua.apellidoMaterno.trim()} ${sua.nombre.trim()}`
        objeto.sua.push(sua)
        objeto.nss = sua.nss
        objeto.salario = sua.salario
        objeto.dias = +sua.dias
        objeto.nombre = sua.nombreCompleto
        objeto.total = +sua.total
        objeto.subtotal = +sua.subtotal
        objeto.infonavit = +sua.infonavit
        objeto.indicador = 1
        if (sua.dias) {
          objeto.busqueda = `${objeto.nombre}|${objeto.nss}`
          this.empleados.push(objeto)
        }
      }
    })
    this.empleados = orderBy(this.empleados, ['indicador', 'nombre'])
    if (this.empleados.length) {
      this.idIndicador = this.empleados[0].indicador
    }
    this.emisionTotal = this.emisionTotal.toFixed(2)
    this.suaTotal = this.suaTotal.toFixed(2)
    this.setParametros()
    this.filtrar()
    this.step = 2
  }

  filtrar () {
    let filtro = this.filtro.toUpperCase()
    this.resultados = this.empleados.filter(item => item.busqueda.contains(filtro) && item.indicador === this.idIndicador)
  }

  guardar () {
    if (!this.empleados.length || this.guardando) return
    this.erroneos = this.seleccionados.filter(item => item.indicador !== 3 && !item.notas).length
    this.resultadosEnviar = [...this.seleccionados]
    this.periodo = this.sua_array.find(item => item.fecha).fecha.getFullYear()
    this.mes = this.sua_array.find(item => item.fecha).fecha.getMonth() + 1
    this.guardando = true
  }

  finalizar (guardo) {
    this.guardando = false
    if (guardo) {
      this.refrescar()
    }
  }

  setParametros () {
    this.$location.search({
      registro_patronal_id: this.data.registro_patronal_id,
      tipo_id: this.data.tipo_id,
      operadora_id: this.data.operadora_id,
    })
  }

  refrescar () {
    this.$state.reload()
  }

  insertarComentario (item, mensaje) {
    if (mensaje || mensaje === '')
      item.mensaje = mensaje
    this.current_message_nss = null
  }

  actualizarSUA (SUA) {
    this.sua_array = obtenerDatos(SUA)
    this.validarSUA()

    this.empleados.forEach((objeto) => {
      objeto.sua = []
      this.suaTotal = 0
      let sua = this.sua_array.find((item) => objeto.nss === item.nss) || null
      if (sua) {
        objeto.indicador = 3
        objeto.salario = 0
        objeto.dias = 0
        objeto.subtotal = 0
        objeto.total = 0
        objeto.infonavit = 0
        objeto.amortizacion = 0
        objeto.emision.forEach((emision) => {
          objeto.total += emision.total || 0
          objeto.dias += emision.dias || 0
          objeto.amortizacion += emision.amortizacion === '-' ? 0 : emision.amortizacion
          objeto.salario = emision.salario || objeto.salario
          objeto.subtotal += emision.subtotal || 0
          objeto.infonavit += emision.subtotalInfonavit || 0
        })
        objeto.amortizacion = objeto.amortizacion === 0 ? '-' : objeto.amortizacion
        objeto.descuento = objeto.descuento === 0 ? '-' : objeto.descuento

        sua.nombreCompleto = `${sua.apellidoPaterno.trim()} ${sua.apellidoMaterno.trim()} ${sua.nombre.trim()}`
        objeto.sua.push(sua)

        if (objeto.amortizacion !== sua.amortizacion) {
          objeto.indicador = 2
          objeto.amortizacion = false
        }

        if (sua.salario !== objeto.salario) {
          objeto.indicador = 2
          objeto.salario = false
        }
        if (sua.dias !== objeto.dias && sua.diasBimestre !== objeto.dias) {
          objeto.indicador = 2
          objeto.dias = false
        }

        if (!objeto.nombre) {
          objeto.nombre = objeto.emision[0].nombre
        }

        if (sanitizar(sua.nombreCompleto) !== sanitizar(objeto.nombre ? objeto.nombre.trim() : '')) {
          objeto.indicador = 2
          objeto.nombre = false
        }
        if (+(sua.subtotal.toFixed(2)) !== +(objeto.subtotal.toFixed(2)) && this.data.tipo_id === 1) {
          objeto.indicador = 2
          objeto.subtotal = false
        }
        if (sua.infonavit !== objeto.infonavit && this.data.tipo_id === 1) {
          objeto.indicador = 2
          objeto.infonavit = false
        }

        if (sua.total !== objeto.total && this.data.tipo_id !== 1) {
          objeto.indicador = 2
          objeto.total = false
        }

        if (this.data.tipo_id !== 1 && objeto.dias && objeto.total && objeto.nombre) {
          objeto.indicador = 3
        }

        if (this.data.tipo_id === 1 && objeto.dias && objeto.subtotal && objeto.infonavit && objeto.nombre) {
          objeto.indicador = 3
        }
        objeto.busqueda = `${objeto.nombre}|${objeto.nss}`
      } else {
        objeto.indicador = 1
      }
    })

    this.sua_array.forEach((sua) => {
      this.suaTotal += this.data.tipo_id === 1 ? sua.subtotal || 0 : sua.total || 0
      if (!this.empleados.find((item) => sua.nss === item.nss)) {
        let objeto = cloneDeep(this.elemento)
        sua.nombreCompleto = `${sua.apellidoPaterno.trim()} ${sua.apellidoMaterno.trim()} ${sua.nombre.trim()}`
        objeto.sua.push(sua)
        objeto.nss = sua.nss
        objeto.salario = sua.salario
        objeto.dias = +sua.dias
        objeto.nombre = sua.nombreCompleto
        objeto.total = +sua.total
        objeto.subtotal = +sua.subtotal
        objeto.infonavit = +sua.infonavit
        objeto.indicador = 1
        if (sua.dias) {
          objeto.busqueda = `${objeto.nombre}|${objeto.nss}`
          this.empleados.push(objeto)
        }
      }
    })
    this.empleados = orderBy(this.empleados, ['indicador', 'nombre'])
    //this.empleados = this.empleados.filter((item) => item.sua.length && item.emision.length)
    this.idIndicador = this.empleados[0].indicador

    this.filtrar()
  }
}

module.component('recursoshumanosPagosSua', {
    controller: RecursosHumanosPagosSuaComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  },
)



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/component.js